/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import * as actions from '../action/stream.action';
import construct = Reflect.construct;
import { StreamState, streamrecord } from './stream.state';
import { AddProductModel } from '../models/add-product.request.model';
import { AddStreamModel } from '../models/add-stream.request.model';

export const initialState: StreamState = (new streamrecord() as unknown) as StreamState;

export function reducer(
  state = initialState,
  { type, payload }: any
): StreamState {
  if (!type) {
    return state;
  }
  switch (type) {

    case actions.ActionTypes.GET_USERS: {
      return Object.assign({}, state, {
        usersLoading: true,
        usersLoaded: false,
        usersFailed: false
      });
    }

    case actions.ActionTypes.GET_USERS_SUCCESS: {
      return Object.assign({}, state, {
        usersLoading: false,
        usersLoaded: true,
        usersFailed: false
      });
    }
    case actions.ActionTypes.GET_USERS_FAIL: {
      return Object.assign({}, state, {
        usersLoading: false,
        usersLoaded: true,
        usersFailed: true
      });
    }

    case actions.ActionTypes.GET_CATEGORIES_LIST: {
      return Object.assign({}, state, {
        categoryListLoading: true,
        categoryListLoaded: false
      });
    }

    case actions.ActionTypes.GET_CATEGORIES_LIST_SUCCESS: {
      return Object.assign({}, state, {
        categoryListLoading: false,
        categoryList: payload.data,
        categoryListLoaded: true,
      });
    }

    case actions.ActionTypes.GET_CATEGORIES_LIST_FAIL: {
      return Object.assign({}, state, {
        categoryListLoading: false,
      });
    }

    case actions.ActionTypes.ADD_PRODUCT: {
      return Object.assign({}, state, {
        addProductLoading: true,
        addProductLoaded: false,
        addProductFailed: false
      })
    }

    case actions.ActionTypes.ADD_PRODUCT_SUCCESS: {
      const addedProduct = new AddProductModel(payload.data);
      return Object.assign({}, state, {
        addProductLoading: false,
        addProductLoaded: true,
        addProductFailed: false,
        addProduct: addedProduct,
        addedProduct: payload
      });
    }

    case actions.ActionTypes.ADD_PRODUCT_FAIL: {
      return Object.assign({}, state, {
        addProductLoading: false,
        addProductLoaded: false,
        addProductFailed: true,
      });
    }

    case actions.ActionTypes.ADD_STREAM: {
      return Object.assign({}, state, {
        addStreamLoading: true,
        addStreamLoaded: false,
        addStreamFailed: false
      })
    }

    case actions.ActionTypes.ADD_STREAM_SUCCESS: {
      return Object.assign({}, state, {
        addStreamLoading: false,
        addStreamLoaded: true,
        addStreamFailed: false,
        addStream: payload
      });
    }

    case actions.ActionTypes.ADD_STREAM_FAIL: {
      return Object.assign({}, state, {
        addStreamLoading: false,
        addStreamLoaded: false,
        addStreamFailed: true,
      });
    }

    case actions.ActionTypes.GET_STREAM_LIST: {
      return Object.assign({}, state, {
        streamListLoading: true
      });
    }

    case actions.ActionTypes.GET_STREAM_LIST_SUCCESS: {
      return Object.assign({}, state, {
        streamListLoading: false,
        streamList: payload.data
      });
    }

    case actions.ActionTypes.GET_STREAM_LIST_FAIL: {
      return Object.assign({}, state, {
        streamListLoading: false,
      });
    }

    default: {
      return state;
    }
  }
}


export const getUsersLoading = (state: StreamState) => state.usersLoading;
export const getUsersLoaded = (state: StreamState) => state.usersLoaded;
export const getUsersFailed = (state: StreamState) => state.usersFailed;
export const usersList = (state: StreamState) => state.userList;

export const categoryListLoading = (state: StreamState) => state.categoryListLoading;
export const categoryList = (state: StreamState) => state.categoryList;
export const categoriesListLoaded = (state: StreamState) => state.categoryListLoaded;

export const addProductLoading = (state: StreamState) => state.addProductLoading;
export const addProductLoaded = (state: StreamState) => state.addProductLoaded;
export const addProductFailed = (state: StreamState) => state.addProductFailed;
export const addProduct = (state: StreamState) => state.addProduct;

export const addStreamLoading = (state: StreamState) => state.addStreamLoading;
export const addStreamLoaded = (state: StreamState) => state.addStreamLoaded;
export const addStreamFailed = (state: StreamState) => state.addStreamFailed;
export const addStream = (state: StreamState) => state.addStream;

export const streamListLoading = (state: StreamState) => state.streamListLoading;
export const streamList = (state: StreamState) => state.streamList;

export const streamLoading = (state: StreamState) => state.streamLoading;
export const stream = (state: StreamState) => state.stream;